"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Menu_1 = require("../../molecules/utils/Menu");
const styled_components_1 = __importDefault(require("styled-components"));
const Overlay_1 = __importDefault(require("../../molecules/utils/Overlay"));
const icons_1 = require("../../atoms/icons");
const Toolbar = styled_components_1.default.div `
  padding: 0 ${({ theme }) => theme.spacings.xs};
  height: ${({ theme }) => theme.spacings.m};
  margin-top: ${({ theme }) => theme.spacings.m};
  margin-bottom: ${({ theme }) => theme.spacings.xl};
  span {
    cursor: pointer;
  }
`;
const Sidebar = styled_components_1.default.div `
  transition: left 0.4s ease;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  max-width: 280px;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  &[data-open="false"] {
    left: -100%;
  }
`;
const Back = styled_components_1.default.span `
  float: left;
`;
const Close = styled_components_1.default.span `
  float: right;
`;
const SidebarWithMenu = ({ open = true, menu, onClose }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(open);
    const [level, setLevel] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (open !== isOpen)
            setIsOpen(open);
    }, [open]);
    const closeSidebar = () => {
        setIsOpen(false);
        onClose && onClose();
    };
    const onOptionClick = (isLink) => {
        if (!isLink) {
            onClose && onClose();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Sidebar, { "data-open": isOpen, children: [(0, jsx_runtime_1.jsxs)(Toolbar, { children: [level > 0 && ((0, jsx_runtime_1.jsx)(Back, { onClick: () => setLevel(level - 1), children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "chevron-left"], color: "grey" }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(Close, { onClick: closeSidebar, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "times"], color: "grey" }, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Menu_1.Menu, { level: level, options: menu, onChangeMenuLevel: (level) => {
                    setLevel(level);
                }, onOptionClick: onOptionClick }, void 0), (0, jsx_runtime_1.jsx)(Overlay_1.default, { isHidden: !isOpen, onClick: closeSidebar }, void 0)] }, void 0));
};
exports.default = SidebarWithMenu;
//# sourceMappingURL=sidebarWithMenu.js.map